export function coolantProcessData(dataArray) {
    const coolantLabels = [];
    const coolantLowerLimit = [];
    const coolantHigherLimit = [];
    const coolantControlLine = [];
    // const coolantData = [];
  
    dataArray.forEach(item => {
      // Push water_ph to phLabels
      coolantLabels.push(item?.machine_charged_date);
  
      // Find the highest value in conc_limit_lower and push to phLowerLimit
      const highestLowerLimit = Math.max(...item?.conc_limit_lower);
      coolantLowerLimit.push(highestLowerLimit);
  
      // Find the highest value in conc_limit_higher and push to phHigherLimit
      const highestHigherLimit = Math.max(...item?.conc_limit_higher);
      coolantHigherLimit.push(highestHigherLimit);
  
      // Push conc_perc_after to phControlLine
      coolantControlLine.push(item?.conc_perc_after);

      // //Push water_ph to phData
      // coolantData.push(item?.coolant_ph)
    });
  
    return {
      coolantLabels,
      coolantLowerLimit,
      coolantHigherLimit,
      coolantControlLine,
      // coolantData
    };
  }
  
  